export default {
  title: 'Pozycje',
  order_note: 'Uwaga do zamówienia',
};
